import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const DefaultTasksLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./default-tasks'),
});
